<template>
  <v-dialog class="dialog" v-model="manageVisible" @click:outside="close" title="Member" width="450px">
    <v-card class="pa-7" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center" dense>
        <v-col class="mt-1 mb-3 ml-5" cols="12" align="start" justify="start">
          <span style="font-weight: 700; font-size: 18px; color: white; align-self: center">
            {{ 'Manage Members' }}
          </span>
        </v-col>
      </v-row>
      <v-container
        color="#21343b"
        style="overflow-y: auto; overflow-x: hidden; width: 100%; height: 250px; justify-content: center"
      >
        <!-- <v-row v-if="isMemberLoading" class="mt-16" justify="center" align="center" fill-height>
          <v-progress-circular color="primary" :width="3" size="50" indeterminate></v-progress-circular>
        </v-row> -->
        <v-row :justify="'center'" v-if="isMemberLoading">
          <v-skeleton-loader
            dark
            type="list-item-avatar"
            width="100%"
            height=""
            class="mb-2"
            style="border-radius: 30px !important"
          ></v-skeleton-loader>
          <v-skeleton-loader
            dark
            type="list-item-avatar"
            width="100%"
            height=""
            class="mb-2"
            style="border-radius: 30px !important"
          ></v-skeleton-loader>
          <v-skeleton-loader
            dark
            type="list-item-avatar"
            width="100%"
            height=""
            class="mb-2"
            style="border-radius: 30px !important"
          ></v-skeleton-loader>
          <v-skeleton-loader
            dark
            type="list-item-avatar"
            width="100%"
            height=""
            style="border-radius: 30px !important"
          ></v-skeleton-loader>
        </v-row>
        <v-row v-else v-for="(member, i) in memberList" v-bind:key="member.name" no-gutters class="mb-3">
          <v-col align="center" align-self="center" cols="1">
            <v-avatar
              :color="!member.userPicture ? member.userDisplayName || member.userFullName : '' | iconBackground"
              class="logo"
              round
              size="30"
            >
              <div class="avatar-bg" v-if="member.userPicture"></div>
              <span class="white--text text-h6 cent" v-if="!member.userPicture">
                {{ member.userDisplayName || member.userFullName | iconFilter }}
              </span>
              <v-img :src="member.userPicture" v-else />
            </v-avatar>
          </v-col>
          <v-col
            align-self="center"
            cols="6"
            style="color: white; font-size: 15px; font-weight: 600"
            class="text-truncate pl-4"
          >
            <span>{{ member.userDisplayName || member.userFullName }}</span>
          </v-col>
          <v-col cols="4">
            <v-menu offset-y v-if="wsInfo.wsCreatedUid !== member.userId && isWsOwner" nudge-bottom="2">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  dark
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :loading="isChangeTypeLoading"
                  :type="buttonClass(member.memberType)"
                  style="width: 120px"
                >
                  {{ member.memberType | firstStrFilter }}
                  <span
                    class="material-icons-round"
                    style="color: #eee; font-size: 20px; font-weight: 400; cursor: pointer"
                    translate="no"
                  >
                    expand_more
                  </span>
                </v-btn>
              </template>
              <v-list dark align="center">
                <v-list-item @click="changeType(member, 'manager')">
                  <v-list-item-title style="font-size: 14px !important">{{ 'Manager' }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeType(member, 'member')">
                  <v-list-item-title style="font-size: 14px !important">{{ 'Member' }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-else
              :type="buttonClass(wsInfo.wsCreatedUid === member.userId ? 'owner' : member.memberType)"
              style="width: 120px"
              dark
              disabled
              elevation="0"
            >
              {{ wsInfo.wsCreatedUid === member.userId ? 'owner' : member.memberType | firstStrFilter }}
            </v-btn>
          </v-col>
          <v-col align="center" align-self="center" cols="1" v-if="isWsOwner">
            <v-btn
              plain
              v-if="member.memberType !== 'manager'"
              @click="deleteMember(i)"
              class="btn-control"
              elevation="0"
              style="width: 20px; min-width: 20px"
            >
              <span
                class="material-icons-round"
                style="color: #eee; font-size: 25px; font-weight: 400; cursor: pointer"
                translate="no"
              >
                clear
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-row>
        <v-col align="center">
          <v-btn color="#289067" dark elevation="0" block @click="close">
            {{ $t('done') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <confirm-modal
      title="Delete Member"
      ref="confirm"
      :isVisible.sync="isVisible"
      :message="$t('cannotUndoneMsg')"
      :cancelLabel="$t('cancel')"
      :confirmLabel="$t('confirm')"
    ></confirm-modal>
  </v-dialog>
</template>

<script>
import { getWsMember, setWsLeave, setWsMemberType } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import ConfirmModal from '@/views/modal/ConfirmModal'
// import Attendee from '@/views/meeting/component/card/Attendee'

export default {
  name: 'ManageDialog',
  components: { ConfirmModal },
  created() {
    this.memberList = []
    this.getMember()
  },
  props: {
    manageVisible: Boolean,
  },
  data() {
    return {
      manageDialogVisible: false,
      memberList: [],
      wsInfo: this.$store.getters.selectedWsInfo,
      isMemberLoading: false,
      isChangeTypeLoading: false,
      isVisible: false,
    }
  },
  computed: {
    ...mapGetters(['isWsOwner']),
  },
  methods: {
    async getMember() {
      try {
        this.isMemberLoading = true
        this.memberList = await getWsMember(this, this.wsInfo.wsId)
      } catch (err) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.isMemberLoading = false
      } finally {
        this.isMemberLoading = false
      }
    },
    close() {
      this.$emit('close', 'Manage')
    },
    async changeType(member, type) {
      this.isChangeTypeLoading = true
      try {
        let result = await setWsMemberType(this, this.$store.getters.selectedWsInfo.wsId, member.userId, type)
        if (result.statusCode === '200') {
          // notify(this, 'Success', this.$t('successUpdateMemberType'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('successUpdateMemberType'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        } else {
          // notify(this, 'Error', this.$t('general.error'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
          member.memberType = type
          this.isChangeTypeLoading = false
        }
      } catch (err) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.isChangeTypeLoading = false
      }
    },
    buttonClass(type) {
      if (type === 'manager') return 'manager'
      else if (type === 'member') return 'member'
      else if (type === 'grant Access') return 'grant'
      else if (type === 'owner') return 'owner'
    },
    deleteMember(member) {
      this.isVisible = true
      // confirm(
      //   this,
      //   this.$t('cannotUndoneMsg'),
      //   '',
      //   'warning',
      //   (callback) =>
      //     callback === 'confirm'
      //       ? this.leave(this.$store.getters.selectedWsInfo.wsId, this.memberList.splice(member, 1)[0].userId)
      //       : true,
      //   (err) => console.log(err)
      // )
      this.$refs.confirm
        .show()
        .then(() => {
          this.leave(this.$store.getters.selectedWsInfo.wsId, this.memberList.splice(member, 1)[0].userId)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async leave(wsId, userId) {
      try {
        await setWsLeave(this, wsId, userId)
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      } catch (error) {
        console.log(error)
        this.errorCode = error.response.status
        // this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))
        // notify(this, 'Error', this.errorCode, 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.errorCode,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isVisible = false
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
}
.v-menu__content {
  z-index: 232 !important;
}
.active_primary {
  background: #25c685;
  border-color: #25c685;
  color: #fff;
  font-size: 18px;
  width: 100%;
}
</style>
